export default function formatDuration(duration: number) {
    // Ensure the duration is positive
    const positiveDuration = Math.abs(duration);

    const seconds = Math.floor(positiveDuration % 60);
    const minutes = Math.floor((positiveDuration / 60) % 60);
    const hours = Math.floor(positiveDuration / (60 * 60));

    let result = `${seconds}s`;
    if (minutes) result = `${minutes}m ${result}`;
    if (hours) result = `${hours}h ${result}`;
    return result;
}
